import { inject, Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest, HttpHeaders } from '@angular/common/http';
import { IxfiLanguageService, Language } from 'header';
import { STORAGE_KEY } from '../../constants/enum.constants';
import { CookieService } from 'ngx-cookie-service';

let refreshCalled = false;

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

      private cookieService = inject(CookieService);
    constructor(private languageService: IxfiLanguageService,) {}

    intercept(req: HttpRequest<any>, next: HttpHandler) {
        let authReq = req;
        let header: HttpHeaders = authReq.headers;

        const lang: Language = this.languageService.selectedLanguage;
        const token = this.cookieService.get(STORAGE_KEY.TOKEN);

        authReq = req.clone({
            headers: req.headers.set('Content-Type', 'application/json')
        });

        if (lang) {
            header = header.append('language', lang?.language_code?.toLowerCase() || 'en');
        }

        // required device type
        header = header.append('device-type', 'web');

        if (token) {
            header = header.append(STORAGE_KEY.TOKEN, token);
            const refreshToken: any = this.cookieService.get(STORAGE_KEY.REFRESH_TOKEN);
            const tokenExpireTime: any = this.cookieService.get(STORAGE_KEY.TOKEN_EXPIRE_TIME);

            if (
                tokenExpireTime &&
                !refreshCalled &&
                new Date(tokenExpireTime * 1000 - 10000) >= new Date() &&
                req.url.includes('refresh-token')
            ) {
                header = header.append('refresh-token', refreshToken);
            }
        }

        authReq = req.clone({ headers: header });

        return next.handle(authReq);
    }
}
